var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-modal-header.j2"] = require( "loyalty-modal-header.j2" );
dependencies["loyalty-page-header.j2"] = require( "loyalty-page-header.j2" );
dependencies["loyalty-short-form.j2"] = require( "loyalty-short-form.j2" );
dependencies["loyalty-long-form.j2"] = require( "loyalty-long-form.j2" );
dependencies["loyalty-full-form.j2"] = require( "loyalty-full-form.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs[loyalty-sign-up]"]));
frame.set("loyaltyConfig", t_1, true);
if(frame.topLevel) {
context.setVariable("loyaltyConfig", t_1);
}
if(frame.topLevel) {
context.addExport("loyaltyConfig", t_1);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "loyaltyModal")) {
output += "\n    ";
env.getTemplate("loyalty-modal-header.j2", false, "loyalty/templates/loyalty-form.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n";
})});
}
else {
output += "\n    ";
env.getTemplate("loyalty-page-header.j2", false, "loyalty/templates/loyalty-form.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n";
})});
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "showShortForm")) {
output += "\n    ";
env.getTemplate("loyalty-short-form.j2", false, "loyalty/templates/loyalty-form.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "showLongForm")) {
output += "\n    ";
env.getTemplate("loyalty-long-form.j2", false, "loyalty/templates/loyalty-form.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n";
})});
}
else {
output += "\n    ";
env.getTemplate("loyalty-full-form.j2", false, "loyalty/templates/loyalty-form.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n";
})});
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-form.j2"] , dependencies)